import { Icon, Typography } from 'components';
import { getEvaluationIconFromColor } from '../Insights/EvaluationGroupsSummary/EvaluationGroupsSummary';

import styles from './ConditionMetricCard.module.css';

type ConditionMetricPillProps = {
  good: number;
  okay: number;
  improve: number;
  support: number;
};

type RenderMetricProps = {
  count: number;
  color: string;
  styleClass: string;
  variant?: Parameters<typeof Typography>[0]['variant'];
  showOnZero?: boolean;
};

export const renderMetric = ({
  count,
  color,
  styleClass,
  variant,
  showOnZero,
}: RenderMetricProps) => {
  if (count <= 0 && !showOnZero) return null;

  return (
    <div className='flex gap-1'>
      <Icon
        name={getEvaluationIconFromColor(color)}
        size='m'
        className={styleClass}
      />
      <Typography variant={variant ?? 'body-s'} className='my-auto'>
        {count}
      </Typography>
    </div>
  );
};

export const ConditionMetricPill = ({
  good,
  okay,
  improve,
  support,
}: ConditionMetricPillProps) => {
  const total = good + okay + support + (improve ? improve : 0);
  if (total === 0) {
    return null;
  }
  return (
    <div className={styles.conditionMetricPill}>
      {renderMetric({ count: support, color: 'red', styleClass: styles.red })}
      {renderMetric({
        count: improve,
        color: 'orange',
        styleClass: styles.orange,
      })}
      {renderMetric({ count: okay, color: 'grey', styleClass: styles.grey })}
      {renderMetric({ count: good, color: 'green', styleClass: styles.green })}
    </div>
  );
};
